import { render, staticRenderFns } from "./EditDeliveryRoutePage.vue?vue&type=template&id=00d213a7"
import script from "./EditDeliveryRoutePage.vue?vue&type=script&lang=js"
export * from "./EditDeliveryRoutePage.vue?vue&type=script&lang=js"
import style0 from "./EditDeliveryRoutePage.vue?vue&type=style&index=0&id=00d213a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports